import Button from "react-bootstrap/Button";
import Collapse from "react-bootstrap/Collapse";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import logo from "../../../assets/90.png";
import Dropdown from "react-bootstrap/Dropdown";
// import DropdownButton from 'react-bootstrap/DropdownButton';
import SecurityIcon from "@mui/icons-material/Security";
import gif from "../../../assets/trade-icc.gif";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ContentCopyTwoToneIcon from "@mui/icons-material/ContentCopyTwoTone";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import LoginIcon from "@mui/icons-material/Login";
import PrivacyTipIcon from "@mui/icons-material/PrivacyTip";
import TradingViewWidget from "../../../components/tradingViewWidget/TradingViewWidget";
import TapeTradingViewWidget from "../../../components/tape/TapeTradingViewWidget";
import "./userdb.scss";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { makeRequest } from "../../../axios";
import { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../authcontext/authContext";
import LogoutIcon from "@mui/icons-material/Logout";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import Heatmap from "../../../components/heatmap/Heatmap";
import Kdepo from "../../../components/userdbComp/kdeposit";
import Kwith from "../../../components/userdbComp/Kwith";
import Kpack from "../../../components/userdbComp/kpack";
import HistoryIcon from "@mui/icons-material/History";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import success from "../../../assets/success.png";
import CancelIcon from "@mui/icons-material/Cancel";
import { useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import gold from "../../../assets/goldR.png";
import silvar from "../../../assets/silvaR.png";
import bronze from "../../../assets/bronzeR.png";
import IndiciesViewWidget from "./Indicies";
import AppleViewWidget from "./Apple";
import AppleStockViewWidget from "./AppleWidget";
import AmazonStockWidget from "./Amazon";
import BoeingStockWidget from "./Boeing";
import SP500StockWidget from "./Sp";
import SPYStockWidget from "./Spys";
import TradingViewWidgettp from "./tradewidget/tekla"
import TradingViewWidgetta from "./tradewidget/tesla";
import TradingViewWidgetts from "./tradewidget/apple";
import TradingViewWidgettb from "./tradewidget/ba";
import TradingViewWidgetty from "./tradewidget/samsung";
import TradingViewWidgettx from "./tradewidget/spx";
import AppleStockWidget from "./appletrade";
import UserInfoWidget from '../ipos';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import WalletIcon from '@mui/icons-material/Wallet';
import translate from 'google-translate-open-api';
import TranslatorWidget from "./translate";
import ShowChartIcon from '@mui/icons-material/ShowChart';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import AddCardIcon from '@mui/icons-material/AddCard';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SystemSecurityUpdateGoodIcon from '@mui/icons-material/SystemSecurityUpdateGood';
import AddLinkSharpIcon from '@mui/icons-material/AddLinkSharp';
import SupportAgentSharpIcon from '@mui/icons-material/SupportAgentSharp';
import { SecuritySharp } from "@mui/icons-material";
import video from "../../../assets/live-trade.mp4"
import ViewportSetter from './ViewportSetter';
import Tranf from "./trans"
import Support from "./support"
import KYCForm from "./kyc";
import AnimatedContainer from "./ref"
import Profil from "./profile";
import {  Container,Col,
  Modal,
  ModalBody,
  ModalHeader,
  ModalTitle,
  ModalFooter,
   Row,Card,CardBody,CardTitle,FormControl,
   FormGroup, InputGroup,FormSelect,
    CardHeader, FormLabel } from 'react-bootstrap';
import Profile from "./profile";
// import video from "../../assets/live-trade.mp4"



function Modalk({ show, onClose, children }) {
  if (!show) return null; // If `show` is false, don't render the modal

  return (
    <div className="modalk-overlay" onClick={onClose}>
      <div className="modalk-content" onClick={(e) => e.stopPropagation()}>
        {/* <button className="modalk-close" onClick={onClose}>
          &times;
        </button> */}
        {children}
      </div>
    </div>
  );
}

const Dashboard = () => {
  const [selectedComponent, setSelectedComponent] = useState("main");
  const [open, setOpen] = useState(true);

  const [allstocks, setAllstocks] = useState([]);
  const [userInfo, setUserInfo] = useState({});
  const [alltransactions, setAllTransactions] = useState([]);
  const [noOftrans, setNoOftrans] = useState();
  const slice = alltransactions.slice(-5, noOftrans);
  const sortedData = slice.sort((a, b) => b.transaction_id - a.transaction_id);
  const { currentUser } = useContext(AuthContext);
  const [amountError, setAmountError] = useState("");
  const [selectedStock, setSelectedStock] = useState(null);
  const [assetHist, setAssetHist] = useState([]);
  const [file, setFile] = useState(null);
  const [kycSuccess, setKycSuccess] = useState("");
  const [err, setErr] = useState(null);
  const navigate = useNavigate();
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };
  console.log(userInfo);
  const ranks = [
    { id: 7, img: bronze },
    { id: 8, img: bronze },
    { id: 9, img: bronze },
    { id: 4, img: silvar },
    { id: 5, img: silvar },
    { id: 6, img: silvar },
    { id: 1, img: gold, rank: "Gold " },
    { id: 2, img: gold, rank: "" },
    { id: 3, img: gold, rank: "" },
  ];


  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const [isOpen1, setIsOpen1] = useState(false);

  const toggleDropdown1 = () => {
    setIsOpen1((prev) => !prev);
  };


  const handleBuyStock = (item) => {
    setSelectedStock(item);
  };
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handlesubmit = async (e) => {
    e.preventDefault();
    try {
      await makeRequest.post("user-info/stock/buy", selectedStock);
    } catch (err) {
      setErr(err.response.data);
      console.log(err);
    }
  };

  const handleKyc = async (e) => {
    e.preventDefault();
    try {
      await makeRequest.post("user-info/kyc");
      setKycSuccess("Upload succesful");
    } catch (err) {
      setErr(err.response.data);
      console.log(err);
    }
  };

  const { logout } = useContext(AuthContext);

  const handlelogout = async () => {
    try {
      await logout();
      navigate("/login");
    } catch (err) {
      setErr(err.response.data);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setSelectedStock((prev) => ({ ...prev, [name]: value }));

    // Validate the amount
    if (name === "amount") {
      if (parseFloat(value) < 15000) {
        setAmountError("This transaction requires more than 15000 USD");
      } else if (parseFloat(value) > userInfo.info?.main_balance) {
        setAmountError("Balance not enough");
      } else {
        setAmountError("");
      }
    }
  };

  useEffect(() => {
    makeRequest.get("user-info/user").then((res) => {
      setUserInfo(res.data);
    });
  }, []);

  useEffect(() => {
    makeRequest.get("user-info/allstocks").then((res) => {
      setAllstocks(res.data);
    });
  }, []);

  useEffect(() => {
    makeRequest.get("user-info/stocks").then((res) => {
      setAssetHist(res.data);
    });
  }, []);

  useEffect(() => {
    makeRequest.get("user-info/alltransactions").then((res) => {
      setAllTransactions(res.data);
    });
  }, []);
  console.log(sortedData, "kolo")

  const balanx = parseInt(userInfo.info?.main_balance,0)
  const balanx1 = balanx.toFixed(2)
  const balanx2 = balanx1.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

  const balank = parseInt(userInfo.info?.trading_balance,0)
  const balank1 = balank.toFixed(2) 
  const balank2 = balank1.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

  const balanj = parseInt(userInfo.info?.asset_balance,0)
  const balanj1 = balanj.toFixed(2) 
  const balanj2 = balanj1.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")


  const balanj4 = parseInt(userInfo.info?.total_deposit,0)
  const balanj5 = balanj4.toFixed(2) 
  const balanj6 = balanj5.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")


  const referralLink = `https://equitradezone.com/register?ref=${userInfo.info?.ref_code}`;


  const copyToClipboard = () => {
    navigator.clipboard.writeText(referralLink);
    alert("Referral link copied!");
  };
  

  return (
    <>
    <ViewportSetter content="width=device-width, initial-scale=1.0"/>
      <div className="dashboard">
        <div className="navba roww ">
          <div className="nav-col roww">
            <Button
              className="n-btn"
              onClick={() => setOpen(!open)}
              aria-controls="example-collapse-text"
              aria-expanded={open}
            >
              <MenuIcon />
            </Button>
          </div>

          <div className="nav-col roww">
          
            <TranslatorWidget/>
            {/* <span>{currentUser.name || "name"}</span> */}
            {/* <AccountCircleIcon /> */}
            <button style={{borderRadius:"5px", padding:"4px"}} onClick={handleOpenModal}><AccountCircleIcon /> Profile </button>

      
             <Modalk show={isModalOpen} onClose={handleCloseModal}>
              <div>
             <p onClick={handlelogout} style={{borderBottom:"1px solid black",padding:".5rem" }} > <LogoutIcon style={{}}/> log out</p>
              <p onClick={() => setSelectedComponent("buy-stock")} style={{borderBottom:"1px solid black", padding:".5rem" }}><AccountCircleIcon style={{}}/> profile</p>
              <p onClick={() => setSelectedComponent("buy-stock")} style={{ padding:".5rem" }}> <WalletIcon/> password</p>
              </div>
              </Modalk>
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <Collapse in={open} dimension="width">
            <div id="example-collapse-text">
              <div
                className="sidebar col"
                style={{
                  width: "250px",
                  background: "#010a12",
                  justifyContent: "space-between",
                }}
              >
                
                <div className="col" style={{ gap: "20px" }}>
                  <Link to="/">
                  <img className="logo" src={logo} alt="" />
                  </Link>
                  <div className="d-board">
                    <button
                      className="d-board-btn"
                      onClick={() => setSelectedComponent("main")}
                    >
                      <DashboardIcon /> Dashboard
                    </button>
                  </div>
                  <div style={{padding:"1rem"}}>
                    <div style={{marginBottom:"1rem", color:"white"}}>ACCOUNT BALANCE</div>
                  <div >
                    <div style={{color:"white", display:"flex", gap:"5px"}}>
                    <div>$ {balank2 || "00"} </div> {" "} <span style={{fontSize:"small"}}>(trading blance)</span>
                    </div>
                    <div style={{color:"white", display:"flex", gap:"5px" }}>
                    <div>$ {balanj2 || "11"} </div> {" "} <span style={{fontSize:"small"}}>(asset intrest)</span>
                    </div>
                  </div>
                  </div>
                  <div>
                    <div className="sidebar-others col ">
                      <div className="col users">
                        <div className="roww" style={{ gap: "7px" }}>
                          
                          <Button
                            variant="success"
                            onClick={() => setSelectedComponent("packages")}
                          >
                            Deposit
                          </Button>{" "}
                          <Button
                            style={{
                              color: "#fff",
                              backgroundImage:
                                "radial-gradient(circle farthest-corner at 0.2% 0.5%, rgba(68, 36, 164, 1) 3.7%, rgba(84, 212, 228, 1) 92.7%)",
                            }}
                            variant="outline-secondary"
                            onClick={() => setSelectedComponent("withdraw")}
                          >
                            Withdraw
                          </Button>
                        </div>
                      </div>

                      <div className="col req">
                       <div style={{borderBottom:"1px solid "}}>
                        <button
                          className="sb-btn"
                          onClick={() => setSelectedComponent("livetrade")}
                          
                        >
                          <span className="small" style={{paddingBottom:"0rem", cursor:"pointer"}}>
                            {" "}
                            <ShowChartIcon /> Live Trading
                          </span>
                        </button>
                        
                <div className="drop-container">
        <div className="drop-toggle" onClick={toggleDropdown1}> <ShowChartIcon/>
        Stock Trading {isOpen1 ? <ArrowDownwardIcon/>: <ArrowForwardIcon/>  }
        </div>
       <div className={`drop-menu ${isOpen1 ? 'open' : ''}`}>
        <a onClick={() => setSelectedComponent("tsla")} className="drop-item">TSLA</a>
        <a onClick={() => setSelectedComponent("spy")} className="drop-item">SPY</a>
        <a onClick={() => setSelectedComponent("spx")} className="drop-item">SPX</a>
        <a  onClick={() => setSelectedComponent("apple-widget")} className="drop-item">Apple</a>
        <a onClick={() => setSelectedComponent("ba")} className="drop-item">BA</a>
        <a onClick={() => setSelectedComponent("amzn")} className="drop-item">AMZN</a>
         </div>
        </div>
                        </div>


                        <div style={{borderBottom:"1px solid"}}>
                        <button
                          className="sb-btn"
                          onClick={() => setSelectedComponent("packages")}
                        >
                          <span className="small">
                            {" "}
                            <AddCardIcon /> Deposit
                          </span>
                        </button>

                        <button
                          className="sb-btn"
                          onClick={() => setSelectedComponent("withdraw")}
                        >
                          <span className="small">
                            {" "}
                            <CreditCardIcon /> Withdrawal
                          </span>
                        </button>
                        <button
                          className="sb-btn"
                          onClick={() => setSelectedComponent("all-transactions")}
                        >
                          <span className="small">
                            {" "}
                            <AccountBalanceIcon /> Transation History
                          </span>
                        </button>
                        </div>
                      </div>
                      <div className="col req">
                        <div>
                        <button
                          className="sb-btn"
                          onClick={() => setSelectedComponent("")}
                          disabled
                        >
                          <span className="small">
                            {" "}
                            <SystemSecurityUpdateGoodIcon /> 2FA
                          </span>
                        </button>

                        <button
                          className="sb-btn"
                          onClick={() => setSelectedComponent("ref")}
                        
                        >
                          <span className="small">
                            {" "}
                            <AddLinkSharpIcon /> Refferal
                          </span>
                        </button>

                        {/* <button
                          className="sb-btn"
                          onClick={() => setSelectedComponent("support")}
                        >
                          <span className="small">
                            {" "}
                            <SupportAgentSharpIcon /> Support
                          </span>
                        </button> */}

                        <button
                          className="sb-btn"
                          onClick={() => setSelectedComponent("kyc")}
                        >
                          <span className="small">
                            {" "}
                            <SecuritySharp /> KYC verification
                          </span>
                        </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="l-out">
                  <button
                    className="sb-btn"
                    onClick={handlelogout}
                    style={{ background: "transparent", border: "none" }}
                  >
                    <span className="small">
                      {" "}
                      <LogoutIcon /> Log out
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </Collapse>

          {selectedComponent === "main" && (
            <div className="main col">
              <div
                className="roww"
                style={{ gap: "7px", alignItems: "center",justifyContent:"space-between" }}
              >
                <div>
                <AccountCircleIcon style={{ color: "#35b94c" }} />
                <span style={{ color: "#fff" }}>
                  ID: {currentUser.users_id || "2784682"}
                </span> {" "} 
                <div style={{marginBottom:"2px"}}>
                <Button style={{ padding: "2px" }} variant="warning">
                  {!currentUser.kyc_status
                    ? "Not verified"
                    : currentUser.kyc_status || "verified"}
                </Button>
                </div>
                </div>
                <div style={{color:"white"}}>
                {currentUser.name} {" "}
                <AccountCircleIcon style={{ color: "#35b94c" }} />
                </div>
              </div>
              <TapeTradingViewWidget />
              <div className="roww kyc">
                <SecurityIcon />
                <div className="col ">
                  <span className="bold">
                    {!currentUser.kyc_status  ? "KYC verification required" : currentUser.kyc_status}
                  </span>
                  <span className="small">
                    {!currentUser.kyc_status
                      ? "Please submit the required KYC information to verify yourself."
                      : ""}
                  </span>
                </div>
              </div>

              <div className="b-div">
                <div className="acc-div roww ">
                  <div className="acc-f col">
                    <span className="bold" style={{ color: "#fff" }}>
                      Account Balance
                    </span>
                    <div className="bal-div">
                      <span>
                        <FiberManualRecordIcon />{" "}
                        <span className="bold">
                          $ {balanx2 || "2565"}{" "}
                        </span>{" "}
                      </span>
                    </div>
                    <hr /><div><MailOutlineIcon/> {" "} Email</div>
                    <span className="small">
                      {" "}
                      {currentUser.email || "email"}{" "}
                    </span>
                    <button className="v-btn" onClick={() => setSelectedComponent("all-transactions")} >View Transactions</button>
                  </div>
                  <div className="acc-sec col">
                    <img className="gif" src={gif} alt="" />
                  </div>
                </div>

                <div className="ot-bal col">
                  <div className="col ot-bal-div">
                    <span className="bold">Trading interest</span>
                    <div className="bal-div">
                      <span>
                        <FiberManualRecordIcon /> ${" "}
                        {balank2 || "00"}{" "}
                      </span>
                    </div>
                    {/* <button className="v-btn" style={{ width: "40%" }}>
                      View Trades
                    </button> */}
                  </div>

                  <div className="col ot-bal-div">
                    <span className="bold">Total Deposit</span>
                    <div className="bal-div">
                      <span>
                        <FiberManualRecordIcon /> ${" "}
                        {balanj6 || "11"}{" "}
                      </span>
                    </div>
                    {/* <button className="v-btn" style={{ width: "40%" }}>
                      View Trades
                    </button> */}
                  </div>
                </div>
              </div>

              <div id="" className="transactins">
                <div className="tr-head">
                  <span className="tr-span">Transactions</span>
                </div>

                {sortedData.length > 0 ? (
                  sortedData.map((item, i) => (
                    <div className="roww tr-map" key={i}>
                      <span className="tr-s-c">{item?.type}</span>
                      <span
                        className="tr-s-c"
                        style={{
                          color: item?.type === "DEPOSIT" ? "green" : "red",
                        }}
                      >
                        {/* {item?.trans_status === "APPROVED" ? "++" : ""}{" "} */}
                        {item?.amount || "Approved"}
                      </span>
                      <span className="tr-s-c">{item?.method_details}</span>
                      <span className="tr-s-c">{item?.trans_status}</span>
                      <span className="tr-s-c">{item?.received}</span>
                    </div>
                  ))
                ) : (
                  <div
                    className=""
                    style={{ height: "80px", textAlign: "center" }}
                  >
                    <h5 style={{ color: "#fff", marginTop: " 40px" }}>
                      No transactions yet
                    </h5>
                  </div>
                )}
              </div>
              <div className="apple-indices">
                <div className="indi">
                  <TradingViewWidgettp />
                </div>
              </div>

              <div className=" roww rf-auth ">
                <div className="col ref">
                  <span className="h2s">Refer and earn </span>
                  <span className="bold">
                    Invite any active trader and earn instant 5% referral bonus
                  </span>
                  <span className="small">Referal link:</span>
                  <span className="small">
                  {referralLink}{" "}
                    <ContentCopyTwoToneIcon onClick={copyToClipboard} />{" "}
                  </span>
                </div>

                <div className="col auth">
                  <div className="roww at-row">
                    <span className="bold">
                      {" "}
                      <CalendarMonthIcon style={{ color: "blue" }} /> Joined at{" "}
                    </span>
                    <span className="">{currentUser.created_at}</span>
                  </div>
                  <div className="roww at-row">
                    <span className="bold">
                      {" "}
                      <LoginIcon style={{ color: "green" }} /> Last login{" "}
                    </span>
                    <span className=""> {currentUser.last_login} </span>
                  </div>
                  <div className="roww  at-row">
                    <span className="bold">
                      {" "}
                      <PrivacyTipIcon style={{ color: "red" }} /> 2 Factor Auth{" "}
                    </span>
                    <span style={{ cursor: "pointer" }} className="">
                      Off
                    </span>
                  </div>
                  <div>
                  <UserInfoWidget />
                  </div>
                </div>
              </div>

              <div
                className=""
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  color: "#fff",
                }}
              ></div>
            </div>
          )}
          {selectedComponent === "amzn" && (
            <div className="stockWidgets">
              <AmazonStockWidget />
            </div>
          )}

          {selectedComponent === "apple-widget" && (
            <div className="stockWidgets">
              <TradingViewWidgetts />
            </div>
          )}
          {selectedComponent === "ba" && (
            <div className="stockWidgets">
              <TradingViewWidgettb />
            </div>
          )}
          {selectedComponent === "spy" && (
            <div className="stockWidgets">
              <TradingViewWidgetty/>
            </div>
          )}
          {selectedComponent === "spx" && (
            <div className="stockWidgets">
              <TradingViewWidgettx />
            </div>
          )}
          {selectedComponent === "tsla" && (
            <div className="stockWidgets">
              <TradingViewWidgetta/>
            </div>
          )}

          {selectedComponent === "deposit" && (
            <div style={{ width: "100%" }}>
              <Kdepo />
              {/* <Kmdepo /> */}
            </div>
          )}
          {selectedComponent === "withdraw" && (
            <div className="degen">
              <Kwith />
            </div>
          )}
          {selectedComponent === "all-transactions" && (
            <>
            <Tranf/>
              {/* <div id="" className="all-transactions">
                <div className="tr-head">
                  <span className="tr-span">Transctions</span>
                </div>

                <div>
                  {alltransactions.map((item, i) => (
                    <div className="roww tr-map">
                      <span className="tr-s-c">{item?.type}</span>
                      <span
                        className="tr-s-c"
                        style={{
                          color: item?.type === "DEPOSIT" ? "green" : "red",
                        }}
                      >
                        {item?.trans_status === "APPROVED" ? "++" : ""}{" "}
                        {item?.amount}{" "}
                      </span>
                      <span className="tr-s-c">{item?.method_details}</span>
                      <span className="tr-s-c">{item?.trans_status}</span>
                    </div>
                  ))}
                </div>
              </div> */}
            </>
          )}
          {selectedComponent === "packages" && <Kpack />}
          {selectedComponent === "buy-stock" && (
            <>
            <Profil/>
            </>
            // <div className="buy-stock">
            //   {allstocks.map((item, i) => (
            //     <div className="card">
            //       <div className="logo-div">
            //         <span className="head">{item.name}</span>
            //         <img src={item.logo} />
            //         <span className="symb">{item.symbol}</span>
            //       </div>
            //       <div className="bottom-div">
            //         <div className="roi">
            //           <span>ROI</span>
            //           <span>+10% - 20%</span>
            //         </div>
            //         <button
            //           onClick={() => {
            //             handleBuyStock(item);
            //             setSelectedComponent("purchase-form");
            //           }}
            //         >
            //           Buy
            //         </button>
            //       </div>
            //     </div>
            //   ))}
            // </div>
          )}
          {selectedComponent === "asset-history" && (
            <div className="buy-stock">
              {assetHist.map((item, i) => (
                <div className="card">
                  <div className="logo-div">
                    <span className="head">{item.name}</span>
                    <img src={item.logo} alt="" />
                    <span
                      className="symb"
                      style={{ color: item.active === 1 ? "green" : "red" }}
                    >
                      {item.active === 1 ? "Active" : "Inactive"}
                    </span>
                  </div>
                  <div className="bottom-div">
                    <div className="roi">
                      <span>{item.status}</span>
                      <span>$ {item.amount}</span>
                    </div>
                    <span style={{ marginLeft: "10px" }}>
                      {item.created_at}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          )}

          {selectedComponent === "purchase-form" && (
            <div
              className="col"
              style={{
                justifyContent: "center",
                gap: "10px",
                alignItems: "center",
                width: "100%",
                height: "255px",
              }}
            >
              <form className="col" style={{ width: "80%", padding: "15px" }}>
                <input
                  className="inpt-purchase"
                  name="name"
                  value={selectedStock?.name}
                />
                <input
                  style={{ display: "none" }}
                  value={selectedStock?.logo}
                  onChange={handleChange}
                />
                <input
                  className="inpt-purchase"
                  name="amount"
                  placeholder="Amount"
                  onChange={handleChange}
                />
                <select
                  className="inpt-purchase"
                  value={selectedStock?.compounding}
                  onChange={handleChange}
                >
                  <option value={selectedStock?.Biweekly_compounding}>
                    Bi-weekly compounding
                  </option>
                  <option value={selectedStock?.Monthly_compounding}>
                    Monthly compounding
                  </option>
                  <option value={selectedStock?.months_compounding}>
                    3 months compounding
                  </option>
                  <option value={selectedStock?.sixMonths_compounding}>
                    6 months compounding
                  </option>
                  <option value={selectedStock?.months_compounding}>
                    9 compounding
                  </option>
                  <option value={selectedStock?.months_compounding}>
                    12 compounding
                  </option>
                </select>
              </form>
              {amountError && <p style={{ color: "red" }}>{amountError}</p>}
              <button className="btn-sub" onClick={handlesubmit}>
                Submit
              </button>
            </div>
          )}
          {selectedComponent === "success" && (
            <div className="scs-div">
              <div className="scs-cnc">
                <CancelIcon onClick={setSelectedComponent("main")} />
              </div>
              <img className="scs-img" src={success} alt="" />
              <span className="scs-span">Successful!</span>
            </div>
          )}
          {selectedComponent === "kyc" && (
            <>
            <KYCForm/>
            </>
          )}

          {selectedComponent === "ref" && (
            <>
            <AnimatedContainer/>
            </>
          )}

          {selectedComponent === "support" && (
            <>
          <Support/>
            </>
          )}
          {selectedComponent === "livetrade" && (
               <div style={{width: "100%"}} >
               <Row>
                <Col style={{width:"100%", height:"100%"}} sm={12}>
                  
                    <CardBody style={{width:"100%",padding:"30px" }}>
                      <video controls autoplay  style={{height:"30%", width:"100%"}}>
                      <source src={video} type="video/mp4"></source>
              
  
                      </video>
                       <div style={{display:"flex", padding:"1rem",justifyContent:"center"}}>
                       <button style={{borderRadius:"5px", padding:"5px", backgroundColor:"#9db8d0"}} class="bounce" onClick={()=>{setSelectedComponent("startlive")}}>
                        START LIVE TRADING
                        </button>
                        </div>
                    </CardBody>
                
                </Col>
               </Row>
              </div>
          )}

          {
          selectedComponent === "startlive" && (
            <div style={{width: "100%"}} >
             <Row style={{height:"100%"}}>
              <Col style={{width:"100%", height:"100%"}} sm={8}>
                 <Card style={{width:"100%", height:"100%",opacity:"0.3",
                  backgroundImage: `url(${logo})`,backgroundSize: 'cover',  backgroundPosition: 'center center', backgroundRepeat:"none" }}>
                  <CardBody style={{width:"100%",padding:"30px", textAlign:"center",  color:"white", fontWeight:"600", marginTop:"20%"
                  , fontSize:"1.5em" }}>
                    <h1 style={{color:"black"}}>
                  Hello!! this
                   interface is not yet open
                    on your account because you’ve
                     not reached the necessary requirements.
                     </h1>
                  </CardBody>
               </Card>
              </Col>
             </Row>
            </div>
            
          )
        }

        </div>
      </div>
    </>
  );
};

export default Dashboard;
